import React from "react";
export default ({ page, onClick, isCurrent }) => (
  <li>
    <a
      {...{
        className: isCurrent ? "pagination-link is-current" : "pagination-link",
        onClick: isCurrent ? undefined : onClick(page)
      }}
    >
      {page}
    </a>
  </li>
);



// WEBPACK FOOTER //
// ./src/components/Pagination/PaginationLink.js